import { useState, useEffect } from 'react';

// Global sidebar state
let globalSidebarOpen = true;
const listeners = new Set<() => void>();

export const useSidebarState = () => {
  const [sidebarOpen, setSidebarOpen] = useState(globalSidebarOpen);

  useEffect(() => {
    const listener = () => setSidebarOpen(globalSidebarOpen);
    listeners.add(listener);

    return () => {
      listeners.delete(listener);
    };
  }, []);

  return sidebarOpen;
};

export const setSidebarState = (open: boolean) => {
  globalSidebarOpen = open;
  listeners.forEach(listener => listener());
};

